import CarDetailDealerVehicle from "./variants/CarDetailDealerVehicle";
import CarDetailDefault from "./variants/CarDetailDefault";

interface CarDetailContent {
  data?: {
    dealervehicle?: boolean;
    [key: string]: any;
  };
}

interface CarDetailProps {
  content: CarDetailContent;
}

const CarDetail = ({ content }: CarDetailProps) => {
  if (!content) {
    return null;
  }

  const { data = {} } = content;
  const isDealerVehicle = Boolean(data.dealervehicle);

  return isDealerVehicle ? (
    <CarDetailDealerVehicle content={content} />
  ) : (
    <CarDetailDefault content={content} />
  );
};

export default CarDetail;
